import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import CommonTable from "../component/CommonTable";
import { useHandleError } from "../hooks/useHandleError";
import axios from "axios";
import { BASE_URL } from "../api";
import MessageToster from "../component/MessageToster";
import { getApiHeaders, shortAddress } from "../utils/helpers";
import Loader from "../component/Loader";
import { exportToExcel } from "../utils/exportData";
import ExportButton from "../component/ExportButton";
import { formatDateDDMMYYYY } from "../utils/dateUtils";
import MobileFilter from "../component/MobileFilter";

const getStatusBadgeClass = (statusStr) => {
  if (!statusStr) return "bg-info";
  const s = String(statusStr).toLowerCase();
  if (["confirm", "1", "success", "approve", "approved", "completed"].includes(s)) return "bg-success";
  if (["pending", "0", "processing"].includes(s)) return "bg-warning";
  if (["rejected", "reject", "cancelled", "cancel", "failed"].includes(s)) return "bg-danger";
  return "bg-info";
};

export default function Transaction() {
  const mid = sessionStorage.getItem("mid");
  const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
  const handleError = useHandleError();
  const [transactionDetail, setTransactionDetail] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [depositLoading, setDepositLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTransactionType, setActiveTransactionType] = useState("");
  const [depositFilters, setDepositFilters] = useState({
    from: "",
    to: "",
    trasaction_type: "All",
  });
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    transactionType: "Deposit",
  });

  useEffect(() => {
    getDepositHistoryData({
      fromDate: "",
      toDate: "",
      transactionType: "Deposit",
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const clearFilters = () => {
    const resetFilters = {
      fromDate: "",
      toDate: "",
      transactionType: "Deposit",
    };
    setFilters(resetFilters);
    setSearchTerm("");
    setSearchQuery("");
    getDepositHistoryData(resetFilters);
  };

  const handleDepositFilterChange = (e) => {
    const { name, value } = e.target;
    setDepositFilters((prev) => ({ ...prev, [name]: value }));
  };

  const getTransactionDetail = async (customFilters = filters) => {
    if (!customFilters.transactionType) {
      MessageToster("error", "Please select transaction type.");
      return;
    };

    const inputBody = {
      // mid: Number(mid),
      from_date: customFilters.fromDate,
      to_date: customFilters.toDate,
      transaction_type: customFilters.transactionType
    };

    // testing ------
    // const inputBody = {
    //   mid: Number(mid),
    //   from_date: "2025-12-01",
    //   to_date: "2025-12-11",
    //   transaction_type: "ALL"
    // };

    setLoading(true);

    try {
      const res = await axios.post(`${BASE_URL}/deposit_withdraw_general/all_type_transaction_history_data`, inputBody, { headers: getApiHeaders() });
      // const res = await axios.post(`http://192.168.29.119:8001/deposit_withdraw_general/all_type_transaction_history_data`, inputBody, { headers: getApiHeaders() });

      if (res.data.code === 200) {

        const result = res.data;

        if (result.data?.length === 0) {
          MessageToster("error", "No transactions found");
          setTransactionDetail([]);
          return;
        }
        MessageToster("success", "Transactions loaded successfully.");
        setTransactionDetail(res.data.data);
      } else {
        MessageToster("error", res.data.message || "Failed to load transactions.");
        setTransactionDetail([]);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getDepositHistoryData = async (customFilters = filters) => {
    if (!customFilters.transactionType) {
      MessageToster("error", "Please select transaction type.");
      return;
    };
    setDepositLoading(true);
    try {
      const body = {
        Transaction_Type: customFilters.transactionType,
        from_date: customFilters.fromDate,
        to_date: customFilters.toDate,
      };
      const res = await axios.post(`${BASE_URL}/account/trasaction_history`, body, { headers: getApiHeaders() });
      if (res.data.code === 200) {
        setSearchQuery(searchTerm);
        const receivedData = res.data.data;
        setTableData(receivedData);
        setActiveTransactionType(customFilters.transactionType);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setDepositLoading(false);
    }
  };

  const handleViewDetails = (invoiceId) => {
    const transaction = transactionDetail.find(t => t.invoiceid.toString() === invoiceId.toString());
    setSelectedTransaction(transaction);
  };



  const filteredData = tableData.filter((item) => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();

    if (activeTransactionType === "Internal Transfer") {
      const idate = item.idate ? formatDateDDMMYYYY(item.idate) : "";
      const loginid = String(item.loginid || "").toLowerCase();
      const email = String(item.email || "").toLowerCase();
      const amount = item.amount != null ? String(item.amount).toLowerCase() : "";
      const type = String(item.tran_type || item.ttype || "").toLowerCase();
      const status = String(item.istatus || "").toLowerCase();
      const remarks = String(item.remarks || "").toLowerCase();

      return (
        idate.includes(query) ||
        loginid.includes(query) ||
        email.includes(query) ||
        amount.includes(query) ||
        type.includes(query) ||
        status.includes(query) ||
        remarks.includes(query)
      );
    }

    if (activeTransactionType === "Withdrowal") {
      const requestedAt = item.requested_at ? formatDateDDMMYYYY(item.requested_at) : "";
      const tokenSymbol = String(item.token_symbol || "").toLowerCase();
      const chainName = String(item.chain_name || "").toLowerCase();
      const amount = item.amount != null ? String(item.amount).toLowerCase() : "";
      const payable = item.payable != null ? String(item.payable).toLowerCase() : "";
      const status = String(item.status || "").toLowerCase();
      const withdrawalAddress = String(item.withdrawal_address || "").toLowerCase();
      const ufname = String(item.ufname || "").toLowerCase();
      const ulname = String(item.ulname || "").toLowerCase();
      const uemail = String(item.uemail || "").toLowerCase();
      const uloginid = String(item.uloginid || "").toLowerCase();

      return (
        requestedAt.includes(query) ||
        tokenSymbol.includes(query) ||
        chainName.includes(query) ||
        amount.includes(query) ||
        payable.includes(query) ||
        status.includes(query) ||
        withdrawalAddress.includes(query) ||
        ufname.includes(query) ||
        ulname.includes(query) ||
        uemail.includes(query) ||
        uloginid.includes(query)
      );
    }

    const ondate = item.ondate ? formatDateDDMMYYYY(item.ondate) : "";
    const cointype = String(item.coinname || item.cointype || "").toLowerCase();
    const payable = item.payable != null ? String(item.payable).toLowerCase() : "";
    const amount = item.amount != null ? String(item.amount).toLowerCase() : "";
    const from = String(item.from || "").toLowerCase();
    const to = String(item.to || "").toLowerCase();
    const tranhash = String(item.tranhash || "").toLowerCase();
    const istatus = String(item.istatus || item.status || "").toLowerCase();
    const msg = String(item.msg || "").toLowerCase();

    return (
      ondate.includes(query) ||
      cointype.includes(query) ||
      payable.includes(query) ||
      amount.includes(query) ||
      from.includes(query) ||
      to.includes(query) ||
      tranhash.includes(query) ||
      istatus.includes(query) ||
      msg.includes(query)
    );
  });

  return (
    <>
      <div id="layout-wrapper">
        {loading && <Loader />}
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">
                      Account Transaction
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                        <div>
                          <label htmlFor="">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            id="example-date-input"
                            name="fromDate"
                            value={filters.fromDate}
                            onChange={handleChange}
                            max={filters.toDate || today}
                          />
                        </div>
                        <div>
                          <label htmlFor="">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            id="example-date-input"
                            name="toDate"
                            value={filters.toDate}
                            onChange={handleChange}
                            min={filters.fromDate || undefined}
                            max={today}
                          />
                        </div>
                        <div>
                          <label htmlFor="">Transaction Type</label>
                          <select
                            className="form-select"
                            name="transactionType"
                            value={filters.transactionType}
                            onChange={handleChange}
                          >
                            <option value="Deposit">Deposit</option>
                            <option value="Withdrowal">Withdrowal</option>
                            <option value="Internal Transfer">Internal Transfer</option>
                          </select>
                        </div>
                        <div>
                          <label htmlFor="">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={() => getDepositHistoryData(filters)}
                          >
                            Search
                          </button>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && filters.transactionType === "Deposit" && !searchTerm}
                          >
                            Clear
                          </button>
                        </div>
                        <div className="ms-auto">
                          <ExportButton
                            disabled={!filteredData || filteredData.length === 0}
                            onClick={() => { exportToExcel(filteredData, "transaction", "payment_transaction") }}
                          />
                        </div>
                      </div>

                      <MobileFilter
                        title="History"
                        onExport={() => { exportToExcel(filteredData, "transaction", "payment_transaction") }}
                        exportDisabled={!filteredData || filteredData.length === 0}
                      >
                        <div>
                          <label htmlFor="">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="fromDate"
                            value={filters.fromDate}
                            onChange={handleChange}
                            max={filters.toDate || today}
                          />
                        </div>
                        <div>
                          <label htmlFor="">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="toDate"
                            value={filters.toDate}
                            onChange={handleChange}
                            min={filters.fromDate || undefined}
                            max={today}
                          />
                        </div>
                        <div>
                          <label htmlFor="">Transaction Type</label>
                          <select
                            className="form-select"
                            name="transactionType"
                            value={filters.transactionType}
                            onChange={handleChange}
                          >
                            <option value="Deposit">Deposit</option>
                            <option value="Withdrowal">Withdrowal</option>
                            <option value="Internal Transfer">Internal Transfer</option>
                          </select>
                        </div>
                        <div>
                          <label htmlFor="">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                        <div className="d-flex gap-2 mt-2">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light flex-grow-1"
                            onClick={() => getDepositHistoryData(filters)}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            Search
                          </button>
                          <button
                            type="button"
                            className="btn btn-light waves-effect waves-light border flex-grow-1"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && filters.transactionType === "Deposit" && !searchTerm}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            Clear
                          </button>
                        </div>
                      </MobileFilter>
                      <CommonTable
                        columns={
                          activeTransactionType === "Internal Transfer" ? [
                            { header: "Date", render: (row) => row.idate ? formatDateDDMMYYYY(row.idate) : "-" },
                            { header: "Login ID", accessor: "loginid" },
                            { header: "Email", accessor: "email" },
                            { header: "Amount", render: (row) => row.amount != null ? Number(row.amount).toFixed(2) : "-" },
                            { header: "Transaction Type", render: (row) => row.tran_type || row.ttype || "-" },
                            {
                              header: "Status", render: (row) => (
                                <span className={`badge ${getStatusBadgeClass(row.istatus || row.status)} fs-6 px-3 py-2`}>
                                  {row.istatus || row.status || "-"}
                                </span>
                              )
                            },
                            { header: "Remarks", accessor: "remarks" },
                            {
                              header: "Action", render: (row) => (
                                <button type="button" className="btn btn-sm btn-soft-primary" data-bs-toggle="modal" data-bs-target="#detailModal" onClick={() => setSelectedItem(row)}>
                                  <i className="mdi mdi-eye-outline fs-5" />
                                </button>
                              )
                            }
                          ] : activeTransactionType === "Withdrowal" ? [
                            { header: "Requested Date", render: (row) => row.requested_at ? formatDateDDMMYYYY(row.requested_at) : "-" },
                            { header: "Token", accessor: "token_symbol" },
                            { header: "Chain", accessor: "chain_name" },
                            { header: "Amount", render: (row) => row.amount != null ? Number(row.amount).toFixed(4) : "-" },
                            { header: "Fee", render: (row) => row.fee_amount != null ? Number(row.fee_amount).toFixed(4) : "-" },
                            { header: "Payable", render: (row) => row.payable != null ? Number(row.payable).toFixed(4) : "-" },
                            {
                              header: "Status", render: (row) => (
                                <span className={`badge ${getStatusBadgeClass(row.status || row.istatus)} fs-6 px-3 py-2`}>
                                  {row.status || row.istatus || "-"}
                                </span>
                              )
                            },
                            {
                              header: "Action", render: (row) => (
                                <button type="button" className="btn btn-sm btn-soft-primary" data-bs-toggle="modal" data-bs-target="#detailModal" onClick={() => setSelectedItem(row)}>
                                  <i className="mdi mdi-eye-outline fs-5" />
                                </button>
                              )
                            }
                          ] : [
                            { header: "Transaction Date", render: (row) => row.ondate ? formatDateDDMMYYYY(row.ondate) : "-" },
                            { header: "Coin Type", render: (row) => row.coinname || row.cointype || "-" },
                            { header: "Payable Amount", render: (row) => row.payable != null ? Number(row.payable).toFixed(4) : row.amount != null ? Number(row.amount).toFixed(4) : "-" },
                            { header: "From Address", render: (row) => row.from ? shortAddress(row.from) : "-" },
                            { header: "To Address", render: (row) => row.to ? shortAddress(row.to) : "-" },
                            { header: "Transection Hash", render: (row) => row.tranhash ? shortAddress(row.tranhash) : "-" },
                            {
                              header: "Status", render: (row) => (
                                <span className={`badge ${getStatusBadgeClass(row.istatus || row.status)} fs-6 px-3 py-2`}>
                                  {row.istatus || row.status || "-"}
                                </span>
                              )
                            },
                            {
                              header: "Action", render: (row) => (
                                <button type="button" className="btn btn-sm btn-soft-primary" data-bs-toggle="modal" data-bs-target="#detailModal" onClick={() => setSelectedItem(row)}>
                                  <i className="mdi mdi-eye-outline fs-5" />
                                </button>
                              )
                            }
                          ]
                        }
                        data={filteredData || []}
                        loading={depositLoading}
                      />
                    </div>
                  </div>
                </div>{" "}
                <div>
                  <div
                    className="modal fade bs-example-modal-center"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Transaction Details</h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setSelectedTransaction(null)}
                          />
                        </div>
                        <div className="modal-body">
                          <div className="text-muted text-center">
                            <div className="bg-primary-subtle p-3">
                              <h4 className="card-title mb-0">
                                Payment Details
                              </h4>
                            </div>
                          </div>
                          {selectedTransaction ? (<>
                            <div className="table-responsive">
                              <CommonTable
                                hideHeader={true}
                                columns={[
                                  { accessor: "label", render: (row) => <td>{row.label}</td> },
                                  { accessor: "value", render: (row) => <td className="fw-bold">{row.value}</td> }
                                ]}
                                data={[
                                  { label: "Invoice ID", value: selectedTransaction.invoiceid || "-" },
                                  { label: "Transaction Date", value: selectedTransaction.ondate || "-" },
                                  { label: "From Account Type", value: selectedTransaction.from_account_type || "-" },
                                  { label: "From Account", value: selectedTransaction.from_account || "-" },
                                  { label: "To Account Type", value: selectedTransaction.to_account_type || "-" },
                                  { label: "To Account", value: selectedTransaction.to_account || "-" },
                                  { label: "Amount", value: selectedTransaction.amount || "-" },
                                  { label: "Currency", value: selectedTransaction.coinname || "-" },
                                  { label: "Transaction Hash", value: selectedTransaction.tranhash || "-" }
                                ]}
                                tableClassName="table mb-0 border text-nowrap"
                              />

                            </div>
                            {/* <div className="card">
                              <div className="mt-4">
                                <div className="text-muted text-center">
                                  <div className="bg-primary-subtle p-3">
                                    <h4 className="card-title mb-0">
                                      Payment Details
                                    </h4>
                                  </div>
                                </div>
                                <div className="table-responsive mt-4">
                                  <table className="table align-middle mb-0">
                                    <tbody>
                                      <tr>
                                        <td>Transaction Hash</td>
                                        <td className="fw-bold">sdfsfsdfsdfd</td>
                                      </tr>
                                      <tr>
                                        <td>Deposit Receipt</td>
                                        <td className="fw-bold">
                                          {" "}
                                          <a
                                            href="#"
                                            className="btn btn-sm btn-soft-success"
                                          >
                                            <i className="mdi mdi-eye-outline fs-5" />
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div> */}
                          </>)
                            :
                            (
                              <p>Loading transaction details...</p>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="detailModal"
            tabIndex={-1}
            aria-labelledby="detailModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="detailModalLabel">
                    {activeTransactionType === "Withdrowal" ? "Withdrawal Details" : activeTransactionType === "Internal Transfer" ? "Transfer Details" : "Deposit History Details"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  {selectedItem && (
                    activeTransactionType === "Internal Transfer" ? (
                      <div className="transaction-details">
                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Login ID</span>
                          <span>{selectedItem.loginid || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Email</span>
                          <span>{selectedItem.email || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Amount</span>
                          <span>{selectedItem.amount != null ? Number(selectedItem.amount).toFixed(2) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Transaction Type</span>
                          <span>{selectedItem.tran_type || selectedItem.ttype || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Date</span>
                          <span>{selectedItem.idate ? formatDateDDMMYYYY(selectedItem.idate) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Status</span>
                          <span
                            className={`badge d-flex justify-content-center align-items-center ${getStatusBadgeClass(selectedItem.istatus || selectedItem.status)} fs-6 px-3 py-2`}
                          >
                            {selectedItem.istatus || "-"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Remarks</span>
                          <span>{selectedItem.remarks || "-"}</span>
                        </div>
                      </div>
                    ) : activeTransactionType === "Withdrowal" ? (
                      <div className="transaction-details">
                        <div className="text-muted text-center mb-3">
                          <div className="bg-primary-subtle p-2 rounded">
                            <h6 className="card-title mb-0">User Information</h6>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Full Name</span>
                          <span>{(selectedItem.ufname || "") + " " + (selectedItem.ulname || "") || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Login ID</span>
                          <span>{selectedItem.uloginid || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Email</span>
                          <span>{selectedItem.uemail || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Mobile</span>
                          <span>{selectedItem.umobile || "-"}</span>
                        </div>

                        <hr />

                        <div className="text-muted text-center mb-3">
                          <div className="bg-primary-subtle p-2 rounded">
                            <h6 className="card-title mb-0">Withdrawal Information</h6>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Token</span>
                          <span>{selectedItem.token_symbol || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Chain</span>
                          <span>{selectedItem.chain_name || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Amount</span>
                          <span>{selectedItem.amount != null ? Number(selectedItem.amount).toFixed(4) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Fee</span>
                          <span>{selectedItem.fee_amount != null ? Number(selectedItem.fee_amount).toFixed(4) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Payable</span>
                          <span>{selectedItem.payable != null ? Number(selectedItem.payable).toFixed(4) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Withdrawal Address</span>
                          <span title={selectedItem.withdrawal_address}>
                            {shortAddress(selectedItem.withdrawal_address)}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Tx Hash</span>
                          <span title={selectedItem.tx_hash}>
                            {selectedItem.tx_hash ? shortAddress(selectedItem.tx_hash) : "-"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Status</span>
                          <span
                            className={`badge d-flex justify-content-center align-items-center ${getStatusBadgeClass(selectedItem.status || selectedItem.istatus)} fs-6 px-3 py-2`}
                          >
                            {selectedItem.status || "-"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Requested At</span>
                          <span>{selectedItem.requested_at ? formatDateDDMMYYYY(selectedItem.requested_at) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Processed At</span>
                          <span>{selectedItem.processed_at ? formatDateDDMMYYYY(selectedItem.processed_at) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Reviewed By</span>
                          <span>{selectedItem.reviewed_by || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Message</span>
                          <span>{selectedItem.msg || "-"}</span>
                        </div>
                      </div>
                    ) : (
                      <div className="transaction-details">
                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">First Name</span>
                          <span>
                            {selectedItem.fname}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Last Name</span>
                          <span>{selectedItem.lname}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Email</span>
                          <span>{selectedItem.email}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Mobile</span>
                          <span>{selectedItem.mobile}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Coin Type</span>
                          <span>{selectedItem.coinname || selectedItem.cointype || "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Amount</span>
                          <span>{selectedItem.amount != null ? Number(selectedItem.amount).toFixed(4) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Payable</span>
                          <span>{selectedItem.payable != null ? Number(selectedItem.payable).toFixed(4) : selectedItem.amount != null ? Number(selectedItem.amount).toFixed(4) : "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Status</span>

                          <span
                            className={`badge d-flex justify-content-center align-items-center ${getStatusBadgeClass(selectedItem.istatus || selectedItem.status)} fs-6 px-3 py-2`}
                          >
                            {selectedItem.istatus || selectedItem.status || "-"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Date</span>

                          <span>
                            {formatDateDDMMYYYY(selectedItem.ondate)}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">From</span>

                          <span title={selectedItem.from}>
                            {shortAddress(selectedItem.from)}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">To</span>

                          <span title={selectedItem.to}>
                            {shortAddress(selectedItem.to)}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Txn Hash</span>

                          <span title={selectedItem.tranhash}>
                            {shortAddress(selectedItem.tranhash)}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Contract</span>

                          <span title={selectedItem.contract_address}>
                            {shortAddress(selectedItem.contract_address)}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between py-2">
                          <span className="fw-semibold">Message</span>
                          <span>{selectedItem.msgcode}</span>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}
